  <template>
  <div class="ui-content dashboard user-height">
    <v-card class="mx-auto normal-card autohg">
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="onlineUser ? headers.filter((x) => x.value !== 'class_name') : headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, idx) in items" :key="idx">
                <td  @click="goToTestList(item)">
                  <span v-if="item.roll_number" class="blue-text">{{ item.roll_number }}</span>
                  <span v-else>{{ item.id }}</span>
                </td>
                <td class="rescheduletest" @click="goToTestList(item)">
                  {{ item.name }}
                </td>
                <td>{{ item.email }}</td>
                <td class="text-center">{{ item.center_name }}</td>
                <td class="text-center">{{ item.batch_name }}</td>
                <td v-if="!onlineUser" class="text-center">{{ item && item.class_name ? item.class_name.replaceAll('##', '-') : '' }}</td>
                <!-- <td class="text-center">{{ item.user_type }}</td> -->
                <td class="text-center">{{ "" }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
const user = JSON.parse(sessionStorage.getItem("user"));
import constants from "@/utils/constants.js";

export default {
  name: "ManageUsersStudent",
  props: ["updateRouteDetails", "searchQuery", "selectedTab"],
  data() {
    return {
      batches: [],
      centers: [],
      classes: [],
      selectedCenterId: [],
      selectedBatch: [],
      selectedClass: null,
      loading: false,
      currentTab: "Test Results",
      status: false,
      orderBy: {
        field: "name",
        order: "ASC",
      },
      items: [],
      oldData: [],
      selctedUserForEdit: null,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      active: 1,
      isLoadingFirstTime: true,
      onlineUser: false,
    };
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      getClasses: "userStore/getClasses",
      getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
      setUserActiveStatus: "userStore/setUserActiveStatus",
    }),
    goToTestList(item) {
      let student_id = item.id;
      let batch_id = item.batch_id;
      let type = item.user_type;
	  let routeName = ""
      sessionStorage.setItem('user-detail',JSON.stringify(item))
	   if(this.$route.name === 'monitor-students'){
		   routeName = "testwise-analysis-coordinator"
	   }
	   else if(this.$route.name === 'students-anaylsis'){
		   routeName ="testwise-analysis-director"
	   }
      this.$router.push({
        name: routeName,
        params: {
          student_id,
          batch_id,
          type,
          name: item.name,
          resetPage: true,
          isCD: true,
        },
      });
    },
    resetPage() {
      this.currentPage = 1;
      this.updateCurrentPageInSession(1);
    },

    requestGetClasses() {
      this.$root.showLoader = true;
      this.getClasses()
        .then((response) => {
          // this.$root.showLoader = false;
          this.classes = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.class_code;
            c.checked = this.selectedClass
              ? this.selectedClass.includes(x.class_code)
              : false;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        if (!this.isLoadingFirstTime) this.resetPage();
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            if (response && response.list && response.list.length) {
              // if (this.selectedBatch) {
              //   let arr = [];
              //   this.selectedBatch.map((xx, i) => {
              //     let isExist = false;
              //     response.list.map((x) => {
              //       if (!isExist) {
              //         isExist = xx === x.id;
              //       }
              //     });
              //     if (!isExist) {
              //       arr.push(xx);
              //     }
              //   });
              //   if (arr && arr.length) {
              //     arr.map((xx) => {
              //       this.selectedBatch.splice(
              //         this.selectedBatch.indexOf(xx),
              //         1
              //       );
              //     });
              //   }
              // }
              this.selectedBatch = this.selectedBatch.filter(b=> response.list.findIndex(l=>l.id===b) !== -1)
              // this.$root.showLoader = false;
              this.batches = response.list.map((x) => {
                let c = {};
                c.text = x.name;
                c.value = x.id;
                c.checked =
                  this.selectedBatch && this.selectedBatch.indexOf(x.id) !== -1;
                return c;
              });
              this.$root.showLoader = false;
            } else {
              this.batches = [];
              this.selectedBatch = [];
            }
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } else {
        this.batches = [];
      }
    },
    getCentersFunction() {
      if (user && user.role_id === constants.ROLES_ID.CO) {
        return "getCentersByUser";
      }
      return "getCenters";
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this[this.getCentersFunction()]()
        .then((response) => {
          // this.$root.showLoader = false;
          this.centers = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            c.checked = this.selectedCenterId.includes(x.id);
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requesGetSelfSignedUpUsers() {
      let reqData = {
        orderBy: this.orderBy,
        role_id: this.roleIds.ST,
        is_approved: 1,
        searchQuery: this.searchQuery,
        active: this.active,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      if (
        this.selectedBatch &&
        this.selectedBatch.length > 0 &&
        this.batches.length != this.selectedBatch.length
      ) {
        reqData.batch_ids = this.selectedBatch;
      }
      if (
        this.selectedCenterId &&
        this.selectedCenterId.length > 0 &&
        this.centers.length != this.selectedCenterId.length
      ) {
        reqData.center_ids = this.selectedCenterId;
      }
      if (
        this.selectedClass &&
        this.selectedClass.length > 0 &&
        this.classes.length != this.selectedClass.length
      ) {
        reqData.class_codes = this.selectedClass;
      }
      this.$root.showLoader = true;
      this.getSelfSignedUpUsers(reqData)
        .then((response) => {
          this.isLoadingFirstTime = false;
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((u) => {
            u.checked = false;
            return u;
          });
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onHeaderAction(e) {
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "batch_name"
      ) {
        this.selectedBatch = e.data.selectedItems;
      } else if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "center_name"
      ) {
        this.selectedCenterId = e.data.selectedItems;
      } else if (
        e.header &&
        e.header.type === "icon-button" &&
        e.header.value === "download_data"
      ) {
        this.downloadStudentData();
      } else if (
        e.header &&
        e.header.value === "class_name"
      ) {
        this.selectedClass = e.data.selectedItems;
      }
    },
    onSortChange() {
      this.requesGetSelfSignedUpUsers();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requesGetSelfSignedUpUsers();
    },
    downloadStudentData() {
      if (this.items.length) {
        let token = sessionStorage.getItem("auth_token");
        let reqData = {};
        if (this.searchQuery) {
          reqData.searchQuery = this.searchQuery;
        }
        if (
          this.selectedClass &&
          this.selectedClass.length > 0 &&
          this.classes.length != this.selectedClass.length
        ) {
          reqData.class_codes = this.selectedClass;
        }
        if (
          this.selectedBatch &&
          this.selectedBatch.length > 0 &&
          this.batches.length != this.selectedBatch.length
        ) {
          reqData.batch_ids = this.selectedBatch;
        }
        if (
          this.selectedCenterId &&
          this.selectedCenterId.length > 0 &&
          this.centers.length != this.selectedCenterId.length
        ) {
          reqData.center_ids = this.selectedCenterId;
        }
        let domainUrl = process.env.VUE_APP_API_URL;
        let params = this.serializeObject(reqData);
        let url =
          domainUrl +
          `/users/download-institute-students-data?token=${token}${params}`;
        //   alert(url);
        window.open(url, "_blank");
      } else {
        this.$toasted.error(`No data to export`, { icon: "info" });
      }
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd && crd.tabDetails && crd.tabDetails[crd.selectedTab]) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
        this.active = crd.tabDetails[crd.selectedTab].showActivated;
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches from session
        this.selectedClass = crd.tabDetails[crd.selectedTab].classIds; // load class from session
      }
      this.requestGetCenters();
      this.requestGetClasses();
    //   if (!crd && !crd.tabDetails[crd.selectedTab].centerIds) {
        this.requesGetSelfSignedUpUsers();
    //   }
    },
  },
  mounted() {
    this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? true : false;
    this.defaultData();
  },
  computed: {
    ...mapState("userStore", ["user"]),

    headers() {
      return [
        { text: "Student Id / \n<span style='color: blue!important;'>Roll No.</span>", value: "roll_number", hideSort: true ,class:'dint-127' },
        { text: "Name", value: "name" },
        { text: "Email ID", value: "email" },
        {
          text: "Center",
          value: "center_name",
          type: "multidropdown",
          options: this.centers,
          class: "text-center",
          allText: "All Centers",
        },
        {
          text: "Batch",
          value: "batch_name",
          type: "multidropdown",
          options: this.batches,
          class: "text-center",
          allText: "All Batches",
        },
        {
          text: "Target Year",
          value: "class_name",
          class: "text-center",
          hideSort: true
        },
        // { text: "User Type", value: "user_type" },
        {
          type: this.user && this.user.role_id && this.user.role_id!==this.roleIds.TR? "icon-button":"",
          value: "download_data",
          width: 10,
          class: "ma-2 black--text download-btn",
		  hideSort:true
        },
      ];
    },
  },
  watch: {
    searchQuery() {
      if (this.selectedTab === this.currentTab)
        setTimeout(() => {
          this.requesGetSelfSignedUpUsers();
        }, 500);
    },
    selectedCenterId(val,oldVal) {
      if (val && val.length !== oldVal.length) {
        this.updateRouteDetails({ type: "centerIds", data: { centerIds:val } });

        this.onCenterSelect(val);
        this.requesGetSelfSignedUpUsers();
      }
    },
    selectedBatch(val,oldVal) {
      if (!this.isLoadingFirstTime && val && val.length!==oldVal.length) {
		  this.resetPage();

      this.updateRouteDetails({ type: "batchIds", data: { batchIds: val } });
      this.requesGetSelfSignedUpUsers();
	  }
    },
    selectedClass(val) {
      if (!this.isLoadingFirstTime && val && val.length) {
		  this.resetPage();
      this.updateRouteDetails({ type: "classIds", data: { classIds: val } });
      this.requesGetSelfSignedUpUsers();
	  }
    },
	selectedTab(val){
      this.requesGetSelfSignedUpUsers();
		
	}
  },
};
</script>
